import { useTranslation } from 'react-i18next';
import RevealWrapper from '@/pages/home/components/RevealWrapper';

const FEATURES = [
  { code: '01', icon: 'ri-moon-line',        titleKey: 'kg.f1.title', descKey: 'kg.f1.desc', tagKey: 'kg.f1.tag' },
  { code: '02', icon: 'ri-emotion-line',      titleKey: 'kg.f2.title', descKey: 'kg.f2.desc', tagKey: 'kg.f2.tag' },
  { code: '03', icon: 'ri-palette-line',      titleKey: 'kg.f3.title', descKey: 'kg.f3.desc', tagKey: 'kg.f3.tag' },
  { code: '04', icon: 'ri-lock-star-line',    titleKey: 'kg.f4.title', descKey: 'kg.f4.desc', tagKey: 'kg.f4.tag' },
  { code: '05', icon: 'ri-star-smile-line',   titleKey: 'kg.f5.title', descKey: 'kg.f5.desc', tagKey: 'kg.f5.tag' },
  { code: '06', icon: 'ri-rocket-line',       titleKey: 'kg.f6.title', descKey: 'kg.f6.desc', tagKey: 'kg.f6.tag' },
];

export default function FeaturesBlock() {
  const { t } = useTranslation();

  return (
    <section id="features" className="bg-[#111111] border-t border-purple-500/10 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-purple-900/5 rounded-full blur-[100px] pointer-events-none" />
      <div className="px-6 lg:px-14 py-8 border-b border-purple-500/10 flex items-center justify-between relative z-10">
        <span className="font-mono text-xs text-purple-400/60 tracking-widest uppercase">{t('kg.features.label')}</span>
        <span className="font-mono text-xs text-purple-400/40">{FEATURES.length} items</span>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-purple-500/[0.14] relative z-10">
        {FEATURES.map((f, idx) => (
          <RevealWrapper key={f.code} direction="up" delay={idx * 80} threshold={0.1} className="h-full border-r border-b border-purple-500/[0.14]">
            <div className="bg-[#111111] p-10 lg:p-14 group hover:bg-[#161616] transition-colors duration-300 h-full relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 border border-purple-500/20 flex items-center justify-center group-hover:border-purple-500/40 transition-colors duration-300">
                    <i className={`${f.icon} text-xl text-purple-400/60 group-hover:text-purple-400 transition-colors duration-300`} />
                  </div>
                  <span className="font-mono text-[10px] text-purple-400/40 border border-purple-500/10 px-2 py-1 tracking-widest">{t(f.tagKey)}</span>
                </div>
                <div className="font-black text-4xl text-purple-500/10 group-hover:text-purple-500/20 transition-colors duration-300 leading-none mb-5">{f.code}</div>
                <h3 className="text-lg font-black text-white mb-4 tracking-tight group-hover:text-purple-100 transition-colors duration-300">{t(f.titleKey)}</h3>
                <p className="text-neutral-500 text-sm leading-loose">{t(f.descKey)}</p>
              </div>
            </div>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
}
